import { render, staticRenderFns } from "./InputChip.vue?vue&type=template&id=04893acf&scoped=true"
import script from "./InputChip.vue?vue&type=script&lang=js"
export * from "./InputChip.vue?vue&type=script&lang=js"
import style0 from "./InputChip.vue?vue&type=style&index=0&id=04893acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04893acf",
  null
  
)

export default component.exports